import React from "react";

import styled from "styled-components/macro";

import {
  AddPaymentMethodCreditCardEntry,
  usePaymentMethodState,
} from "Payments/AddPaymentMethod";
import AddPaymentMethodBankAccountEntry from "Payments/AddPaymentMethod/AddPaymentMethodBankAccountEntry";
import { ManagePaymentMethodsProvider } from "Payments/ManagePaymentMethods/ManagePaymentMethodsContext";
import { LeadText } from "Payments/PaymentPage/PaymentFormScreen/styles";
import { motion } from "framer-motion";

import { useInitialPaymentType } from "../../paymentFormStateHooks";

import AdditionalSettings from "./AdditionalSettings";

export default function PaymentMethodElements({
  showCloseButton,
  isInitialPaymentMethodStep,
  handleCloseClick,
  showCard,
  setInputErrors,
  shouldClearDisplayMessages,
  setShouldClearDisplayMessages,
  billingAddress,
  name,
  inputErrors,
  phoneNumber,
  sharableWith,
  network,
}) {
  const { initialPaymentType } = useInitialPaymentType();
  const { paymentType } = usePaymentMethodState();
  const isBank = paymentType === "bank";

  return (
    <ManagePaymentMethodsProvider>
      {/* ^^^ This provider is only necessary as long as WePay is an option */}
      <LeadText>
        What {isBank ? "account" : "card"} would you like to use?
      </LeadText>
      <OuterWrapper>
        {showCloseButton ? (
          <CloseButton
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.6 }}
            transition={{ delay: isInitialPaymentMethodStep ? 0 : 0.8 }}
            onClick={handleCloseClick}
            className="fas fa-times-circle"
            whileHover={{ opacity: 1, scale: 1.1 }}
            whileTap={{ opacity: 1, scale: 0.95 }}
          />
        ) : null}

        <CardContainer>
          <CardWrapper>
            {showCard ? (
              <AddPaymentMethodCreditCardEntry
                show={showCard}
                setInputErrors={setInputErrors}
                shouldClearDisplayMessages={shouldClearDisplayMessages}
                setShouldClearDisplayMessages={setShouldClearDisplayMessages}
                existingUserName={name}
                existingZip={billingAddress?.zip}
              />
            ) : (
              <AddPaymentMethodBankAccountEntry
                initialPaymentType={initialPaymentType}
                setInputErrors={setInputErrors}
              />
            )}
          </CardWrapper>
        </CardContainer>
      </OuterWrapper>
      <AdditionalSettings
        inputErrors={inputErrors}
        setInputErrors={setInputErrors}
        setShouldClearDisplayMessages={setShouldClearDisplayMessages}
        hasMobilePhone={phoneNumber && true}
        sharableWith={sharableWith}
        defaultOpen={sharableWith && sharableWith.length > 0} // DOUBLE CHECK WHETHER THIS IS WHERE YOU WANT THIS
        networkName={network?.name}
      />
    </ManagePaymentMethodsProvider>
  );
}

const OuterWrapper = styled.div`
  position: relative;
`;

const CloseButton = styled(motion.div)`
  position: absolute;
  top: 0;
  left: -32px;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 7px;
  margin-top: 7px;
  opacity: 0.6;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
`;

const CardContainer = styled.div`
  margin-left: -14px;
  margin-right: -14px;
  display: flex;
  justify-content: center;
  margin-top: 14px;
  height: min(252px, calc((100vw - 16px) * 53.98 / 85.6));
`;

const CardWrapper = styled(motion.div)`
  width: min(400px, calc(100vw - 16px));
  position: absolute;
`;
